export default __webpack_public_path__ + "static/media/slider1.0bdc4c54.png";